module.exports = __webpack_public_path__ + "img/logo_login.61ea571d.png";